import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faChevronDown,
  faCircle,
  faPrint,
} from "@fortawesome/free-solid-svg-icons";

import styles from "../../styles/patient-page-modules/Createpatient.module.css";
import cloud from "../../assets/images/Vector_1047.png";
import toast from "react-hot-toast";
import axios from "axios";
import { BASE_URL, BASE_URL_ML, tenoviDevices } from "../../utils/constants";
import Spinner from "../../components/spinner";
import AddProviderModal from "../../components/patient-detail/patient-modals/addProviderModal";
import MultiSelectTagInput from "../../components/multiSelectTagInput";
import DatePicker from "../../components/shared-modules/DatePicker/DatePicker";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import { handleApiError } from "../../utils/handleApiError";
import {
  processDocumentsForAI,
  extractDocumentIds,
} from "../../services/patient/rag";
import Input from "../../components/ui/input";

import AddContactisView from "../../components/patient-settings/add-contacts/view";
import Button from "../../components/button-v1";
import { FaEdit, FaTrash } from "react-icons/fa";
import { USANumberFormat } from "../../utils/helper";
import { parseDateSafe } from "../../utils/dateFormatters";
import clsx from "clsx";
import { getNurses } from "../../services/staff";
import { useQuery } from "@tanstack/react-query";
import { getUserRoleSlug } from "../../utils/authorization";

const CreatePatient = ({ CaseManager = "false" }) => {
  const backLink =
    CaseManager === "true" ? "/admin-case-manager" : "/dashboard";
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const [uploadedPdf, setUploadedPdf] = useState(null);
  const [openPdf, setOpenPdf] = useState(true);
  const [caseManagers, setCaseManagers] = useState([]);
  const [staff, setStaff] = useState(false);
  const [adminStaff, setAdminStaff] = useState(false);
  const [rpmCodes, setRpmCodes] = useState([]);
  const [ccmCodes, setCcmCodes] = useState([]);
  const [rpmMissingCodes, setRpmMissingCodes] = useState();
  const [ccmMissingCodes, setCcmMissingCodes] = useState([]);
  const [providers, setProviders] = useState([]);
  const [renderProvider, setRenderProvider] = useState(false);
  const [checkedStaff, setcheckedStaff] = useState({});
  const [extractedData, setExtractedData] = useState({});
  const [isAddProviderModalOpen, setIsAddProviderModalOpen] = useState(false);
  const roleSlug = getUserRoleSlug();
  const showVitalSmsToggle = [
    "toca_admin",
    "toca_care_manager",
    "toca_super_admin",
  ].includes(roleSlug);
  const [formData, setFormData] = useState({
    // file
    consent_form: null,
    doctor_notes: null,
    is_consent_form: true,
    is_doctor_notes: false,

    // user
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    password: "",
    confirm_password: "",
    gender: "male",
    primary_phone: "",
    secondary_phone: "",
    tertiary_phone: "",
    dob: (() => {
      const date = new Date();
      const formatted = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(date);
      return formatted;
    })(),
    address_line_1: "",
    address_line_2: "",
    city: "",
    postal_code: "",
    state: "",
    created_at: (() => {
      const date = new Date();
      const formatted = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(date);
      return formatted;
    })(),

    // others
    rpm: true,
    ccm: false,
    vital_sms_alert: false,
    rpm_codes: [],
    ccm_codes: [],
    preferred_language: "English",
    case_manager: "",
    provider: "",
    secondary_provider: "",
    facility: "",
    race: "",
    family_member_name: "",
    family_member_phone: "",
    family_member_email: "",
    physician_name: "",
    physician_phone: "",
    physician_email: "",
    acknowledgment: false,
    device_policy: false,
    participation_agreement: false,
    rpm_disclaimer: false,
    verbal_consent: false,
    nurse: "",
    medical_record_number: "",

    // data_bounds - kept empty for backend to use organizational defaults

    glucose_low: "",
    glucose_high: "",

    systolic_low: "",
    systolic_high: "",

    diastolic_low: "",
    diastolic_high: "",

    heart_rate_low: "",
    heart_rate_high: "",

    temperature_low: "",
    temperature_high: "",

    weight_low: "",
    weight_high: "",

    oxygen_low: "",
    oxygen_high: "",

    // device_info
    device_imei: "",
    device_assgined_at: "",
    device_name: "Tenovi Cellular BPM - L",
    device_type: "cellular",
    gateway_id: "",

    // medications and conditions
    medications: [],
    chronic_conditions: [],
  });
  const [fieldErrors, setFieldErrors] = useState({});
  const scrollToTopOnError = () => {
    try {
      setIsSectionOpen((prev) => ({ ...prev, sec1: true }));
      setTimeout(() => {
        if (typeof window !== "undefined" && window?.scrollTo) {
          window.scrollTo({ top: 200, behavior: "smooth" });
        }
      }, 0);
    } catch (e) {
      // no-op in non-DOM environments
    }
  };
  const [isSectionOpen, setIsSectionOpen] = useState({
    sec1: true,
    sec2: false,
    sec3: false,
    sec4: false,
    sec5: false,
  });

  // Local contacts state for AddContactisView
  const [contactNumbers, setContactNumbers] = useState([]);
  const [isContactsModalOpen, setIsContactsModalOpen] = useState(false);
  const [editingContactId, setEditingContactId] = useState(null);

  const location_id = JSON.parse(sessionStorage.getItem("current_loc")).id;

  if (!location_id) {
    toast.error("Please create or activate a location first.");
    navigate("/dashboard");
  }

  // add provider modal functions
  const openAddProviderModal = () => {
    setIsAddProviderModalOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeAddProviderModal = () => {
    setIsAddProviderModalOpen(false);
    document.body.style.overflow = "auto";
  };
 const {
    data: nurseList,
    isLoading: isLoadingStaff,
    error: staffError,
  } = useQuery(["nurse-list"], () => getNurses(true));
  // fetch providers
  useEffect(() => {
    const fetchProvider = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const account_id = sessionStorage.getItem("acc_id");

        const url = `${BASE_URL}/accounts/${account_id}/providers/`;
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const fetchedProviders = Array.isArray(response.data)
          ? response.data
          : [];
        setProviders(fetchedProviders.filter((provider) => provider.active));
      } catch (error) {
        handleApiError(error);
      }
    };

    fetchProvider();
  }, [renderProvider]);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const account_id = sessionStorage.getItem("acc_id");
    const location_id = JSON.parse(sessionStorage.getItem("current_loc")).id;

    // const fetchStaff = async () => {
    //   const url = `${BASE_URL}/accounts/${account_id}/${location_id}/staff-list/?status=active`;
    //   const response = await axios.get(url, {
    //     headers: { Authorization: `Bearer ${token}` },
    //   });
    //   return response.data.staff;
    // };
    const fetchCaseManager = async () => {
      const url = `${BASE_URL}/accounts/${account_id}/case-managers/?for_assignment=true`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    };

    const fetchRpmCodes = async () => {
      const url = `${BASE_URL}/rpm/${account_id}/rpm-codes/`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    };

    const fetchCcmCodes = async () => {
      // const url = `${BASE_URL}/ccm/${account_id}/ccm-codes/`;
      const url = `${BASE_URL}/conditions/${account_id}/${location_id}/chronic-conditions/`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    };

    const fetchAllData = async () => {
      try {
        // const [caseManagerdata, staffData, rpmCodes, ccmCodes] =
        const [caseManagerdata, rpmCodes, ccmCodes] =
          await Promise.all([
            fetchCaseManager(),
            // fetchStaff(),
            fetchRpmCodes(),
            fetchCcmCodes(),
          ]);
        setCaseManagers(
          caseManagerdata.filter((_caseManager) => _caseManager.first_name)
        );

        // setStaff(
        //   staffData.filter((staff) =>
        //     staff?.account_roles?.some((_role) => _role.name === "Case Manager")
        //   )
        // );
        // setAdminStaff(
        //   staffData.filter((staff) =>
        //     staff.account_roles?.some((_role) => _role.name === "Account Admin")
        //   )
        // );
        setRpmCodes(rpmCodes);
        setCcmCodes(ccmCodes);
      } catch (error) {
        handleApiError(error);
      }
    };

    fetchAllData();
  }, []);

  const states = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];
  const languages = [
    "English",
    "Spanish",
    "French",
    "Farsi",
    "Armenian",
    "Arabic",
    "Vietnamese",
    "Chinese",
    "Hindi",
    "Tagalog",
    "Russian",
    "Korean",
  ];

  const handleStaffCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    setcheckedStaff((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const handleAcknowledgementCheck = (e) => {
    const { name, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked,
    }));
  };

  const toggleSection = (section) => {
    setIsSectionOpen((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    // clear field error on change
    if (fieldErrors[name]) {
      setFieldErrors((prev) => ({ ...prev, [name]: undefined }));
    }
  };

  const handleMultiSelectInputChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const renderMultiselectOptions = (
    data,
    idKey = "id",
    nameFormatter = (item) => item.name
  ) => {
    if (!Array.isArray(data)) return [];

    return data.map((item) => ({
      id: item[idKey],
      name: nameFormatter(item),
    }));
  };

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;

    // Handle CCM logic
    if (name === "ccm") {
      setFormData((prevState) => ({
        ...prevState,
        ccm: checked,
        rpm: !checked && !prevState.rpm ? true : prevState.rpm,
      }));
    } else {
      // Default checkbox behavior
      setFormData((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    }
  };
  const handleDateChange = (date) => {
    const formattedDate = date ? date.toISOString().split("T")[0] : "";
    setFormData({
      ...formData,
      dob: formattedDate,
    });
  };

  const handleCreatedAtDateChange = (date) => {
    const formattedDate = date ? date.toISOString().split("T")[0] : "";
    setFormData({
      ...formData,
      created_at: formattedDate,
    });
  };

  const handleDeviceAssignedAtDateChange = (date) => {
    const formattedDate = date ? date.toISOString().split("T")[0] : "";
    setFormData({
      ...formData,
      device_assgined_at: formattedDate,
    });
  };
  const handleFileChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];

    if (file && file.type !== "application/pdf") {
      return toast.error("Only PDF file is supported");
    }

    if (file && file.type === "application/pdf") {
      setUploadedPdf(URL.createObjectURL(file));

      setFormData((prevFormData) => ({
        ...prevFormData,
        consent_form: prevFormData.is_consent_form ? file : null,
        doctor_notes: prevFormData.is_doctor_notes ? file : null,
      }));
    }
  };
  const handleDropZoneClick = () => {
    document.getElementById("consent_form").click();
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];

    if (file && file.type === "application/pdf") {
      setUploadedPdf(URL.createObjectURL(file));

      // Update form data with dummy data
      setFormData((prevFormData) => ({
        ...prevFormData,
        // ...dummyData,
        consent_form: file,
      }));
    } else if (file) {
      // If not a PDF, just update the consent_form field
      setFormData((prevFormData) => ({
        ...prevFormData,
        consent_form: file,
      }));
    }
  };
  const handleFileCheckBoxChange = (event) => {
    const { name } = event.target;

    setFormData((prevData) => ({
      ...prevData,
      is_consent_form: name === "is_consent_form",
      is_doctor_notes: name === "is_doctor_notes",
    }));
  };

  const extractData = async () => {
    let fileType = "";
    let file = null;

    if (formData.is_consent_form) {
      fileType = "consent_form";
      file = formData.consent_form;
    } else if (formData.is_doctor_notes) {
      fileType = "dr_note";
      file = formData.doctor_notes;
    }
    if (!fileType || !file) return;

    const icdCodes = formData.is_consent_form
      ? [...(rpmCodes ?? [])].map((code) => ({
          code: code.code,
          desease_type: code.description,
        }))
      : [...(ccmCodes ?? [])].map((code) => ({
          code: code.icd_code,
          desease_type: code.name,
        }));
    const queryString = encodeURIComponent(JSON.stringify(icdCodes));

    const url = `${BASE_URL_ML}/scanner/extract_form?form_type=${fileType}&codes=${queryString}`;
    const mlFormData = new FormData();

    mlFormData.append("file", file);

    try {
      setFileLoading(true);
      const response = await axios.post(url, mlFormData);
      setExtractedData(response.data);
      toast.success("Data extraction completed...!");
    } catch (error) {
      handleApiError(error);
    } finally {
      setFileLoading(false);
    }
  };
  const autoSelectCodes = (mlConditions, allCodes, type) => {
    const selectedIds = [];
    const missingConditions = [];

    mlConditions?.forEach((condition) => {
      let found;

      if (type === "RPM") {
        found = allCodes?.find((code) => code.code === condition);
      } else if (type === "CCM") {
        found = allCodes?.find((code) => code.icd_code === condition);
      }

      if (found) {
        selectedIds.push(found.id);
      } else {
        missingConditions.push(condition);
      }
    });

    //  Set missing codes appropriately
    if (type === "RPM") {
      setRpmMissingCodes(missingConditions);
      setRpmCodes(selectedIds);
    } else if (type === "CCM") {
      setCcmMissingCodes(missingConditions);
      setCcmCodes(selectedIds);
    }

    // return selectedIds;
    return missingConditions;
  };

  function patientChronicConditions(chronicConditions, extractedICDCodes) {
    return chronicConditions
      ?.filter((cond) => extractedICDCodes?.includes(cond.icd_code))
      ?.map(
        ({
          name,
          icd_code,
          prognosis,
          symptoms,
          treatment_goals,
          planned_interventions,
        }) => ({
          name,
          icd_code,
          prognosis,
          symptoms,
          treatment_goals,
          planned_interventions,
        })
      );
  }

  function patientMedications(medicationStrings) {
    return medicationStrings?.length > 0
      ? medicationStrings.map((med) => {
          const parts = med.split("_").map((part) => part.trim());

          return {
            name: parts[0] || "",
            strength: parts[1] || "",
            directions: parts[2] || "",
          };
        })
      : [];
  }

  const populateData = (extractedData) => {
    if (formData.is_consent_form) {
      // preferred_language: extractedData.language
      // ? extractedData.language[0]
      // : prevFormData.preferred_language,

      if (
        extractedData.language &&
        !languages.includes(extractedData.language[0])
      ) {
        toast.error(
          "AI is unbale to extract the supported language, Select Manually",
          {
            removeDelay: 3,
          }
        );
      } else {
        setFormData((prevState) => ({
          ...prevState,
          preferred_language: extractedData.language
            ? extractedData.language[0]
            : prevState.preferred_language,
        }));
      }

      setFormData((prevFormData) => ({
        ...prevFormData,
        first_name: extractedData.first_name || prevFormData.first_name,
        last_name: extractedData.last_name || prevFormData.last_name,
        dob: extractedData.birthday
          ? (() => {
              let date;
              if (typeof extractedData.birthday === "string") {
                if (
                  extractedData.birthday.includes("-") &&
                  extractedData.birthday.length === 10
                ) {
                  const [year, month, day] = extractedData.birthday.split("-");
                  date = new Date(year, month - 1, day);
                } else if (extractedData.birthday.includes("/")) {
                  date = parseDateSafe(extractedData.birthday) || new Date();
                } else {
                  date = parseDateSafe(extractedData.birthday) || new Date();
                }
              } else {
                date = parseDateSafe(extractedData.birthday) || new Date();
              }

              const formatted = new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              }).format(date);
              return formatted;
            })()
          : prevFormData.dob,
        device_assgined_at: extractedData.Date
          ? (() => {
              let date;
              if (typeof extractedData.Date === "string") {
                if (
                  extractedData.Date.includes("-") &&
                  extractedData.Date.length === 10
                ) {
                  const [year, month, day] = extractedData.Date.split("-");
                  date = new Date(year, month - 1, day);
                } else if (extractedData.Date.includes("/")) {
                  date = parseDateSafe(extractedData.Date) || new Date();
                } else {
                  date = parseDateSafe(extractedData.Date) || new Date();
                }
              } else {
                date = parseDateSafe(extractedData.Date) || new Date();
              }

              const formatted = new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              }).format(date);
              return formatted;
            })()
          : prevFormData.device_assgined_at,
        created_at: extractedData.Date
          ? (() => {
              let date;
              if (typeof extractedData.Date === "string") {
                if (
                  extractedData.Date.includes("-") &&
                  extractedData.Date.length === 10
                ) {
                  const [year, month, day] = extractedData.Date.split("-");
                  date = new Date(year, month - 1, day);
                } else if (extractedData.Date.includes("/")) {
                  date = parseDateSafe(extractedData.Date) || new Date();
                } else {
                  date = parseDateSafe(extractedData.Date) || new Date();
                }
              } else {
                date = parseDateSafe(extractedData.Date) || new Date();
              }

              const formatted = new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              }).format(date);
              return formatted;
            })()
          : prevFormData.created_at,
        email: extractedData.patient_email || prevFormData.email,
        primary_phone: extractedData.phone_no || prevFormData.primary_phone,
        secondary_phone:
          extractedData.secondary_no || prevFormData.secondary_phone,
        gender:
          extractedData.sex === "M" ||
          extractedData.sex === "Male" ||
          extractedData.sex === "male"
            ? "male"
            : extractedData.sex === "F" ||
              extractedData.sex === "Female" ||
              extractedData.sex === "female"
            ? "female"
            : prevFormData.gender,
        city: extractedData.city || prevFormData.city,
        state: extractedData.state,
        postal_code: extractedData.zip || prevFormData.postal_code,
        address_line_1: extractedData.address || prevFormData.address_line_1,
        // physician_name: extractedData.physician || prevFormData.physician_name,
        // case_manager: extractedData.physician || prevFormData.physician_name,
        // preferred_language: extractedData.language
        //   ? extractedData.language[0]
        //   : prevFormData.preferred_language,
        // rpm_codes: autoSelectCodes(
        //   extractedData.chronic_condition,
        //   rpmCodes,
        //   "RPM"
        // ),

        rpm_codes: extractedData.chronic_condition || prevFormData.rpm_codes,
        // ccm_codes: extractedData.chronic_condition || prevFormData.ccm_codes,
        acknowledgment:
          extractedData.acknowledgment || prevFormData.acknowledgment,
        verbal_consent:
          extractedData.verbal_consent || prevFormData.verbal_consent,
        device_policy:
          extractedData.device_policy || prevFormData.device_policy,
        participation_agreement:
          extractedData.participation_agreement ||
          prevFormData.participation_agreement,
        rpm_disclaimer:
          extractedData.rpm_disclaimer || prevFormData.rpm_disclaimer,
        device_imei: extractedData.IMEI || prevFormData.device_imei,
        device_type: extractedData.device || prevFormData.device_type,
        medical_record_number:
          extractedData.Medical_Record_Number || extractedData.medical_record_number || prevFormData.medical_record_number,
      }));
    }

    if (formData.is_doctor_notes) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        first_name: extractedData.First_Name || prevFormData.first_name,
        last_name: extractedData.Last_Name || prevFormData.last_name,
        dob: extractedData.Birthday
          ? (() => {
              let date;
              if (typeof extractedData.Birthday === "string") {
                if (
                  extractedData.Birthday.includes("-") &&
                  extractedData.Birthday.length === 10
                ) {
                  const [year, month, day] = extractedData.Birthday.split("-");
                  date = new Date(year, month - 1, day);
                } else if (extractedData.Birthday.includes("/")) {
                  date = new Date(extractedData.Birthday);
                } else {
                  date = new Date(extractedData.Birthday);
                }
              } else {
                date = new Date(extractedData.Birthday);
              }

              const formatted = new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              }).format(date);
              return formatted;
            })()
          : prevFormData.dob,
        gender:
          extractedData.Gender === "Male"
            ? "male"
            : extractedData.Gender === "Female"
            ? "female"
            : prevFormData.gender,
        blood_pressure: extractedData.BP_value || prevFormData.blood_pressure,
        weight: extractedData.Weight || prevFormData.weight,
        chronic_conditions:
          patientChronicConditions(ccmCodes, extractedData.Chronic_condition) ||
          prevFormData.chronic_conditions,
        medications:
          patientMedications(extractedData.Medication) ||
          prevFormData.medications,
        allergies: extractedData.Allergies || prevFormData.allergies,
        rpm: false,
        ccm: true,
        ccm_codes: autoSelectCodes(
          extractedData.Chronic_condition,
          ccmCodes,
          "CCM"
        ),
        medical_record_number: extractedData.Medical_Record_Number || extractedData.medical_record_number || prevFormData.medical_record_number,
          
      }));
    }
  };

  useEffect(() => {
    if (formData.is_consent_form && formData.consent_form) {
      extractData();
    } else if (formData.is_doctor_notes && formData.doctor_notes) {
      extractData();
    }
  }, [formData.consent_form, formData.doctor_notes]);

  useEffect(() => {
    if (extractedData) {
      populateData(extractedData);
    }
  }, [extractedData]);

  useEffect(() => {
    if (
      extractedData &&
      extractedData.secondary_no &&
      !contactNumbers.some(
        (number) =>
          number.number === USANumberFormat(extractedData.secondary_no)
      )
    ) {
      setContactNumbers((prev) => [
        ...prev,
        {
          label: "Secondary",
          number: USANumberFormat(extractedData.secondary_no),
          number_type: "calling",
          relation: "relative",
          is_primary: false,
        },
      ]);
    }
  }, [extractedData]);

  useEffect(() => {
    if (extractedData && extractedData.chronic_condition) {
      setRpmCodes(extractedData.chronic_condition);
      // setCcmCodes(extractedData.chronic_condition);
    }
  }, [extractedData]);

  // converting formdata into groups
  const current_location = JSON.parse(sessionStorage.getItem("current_loc"));

  const sanitizeField = (value) =>
    value === "" || value === undefined ? null : value;

  // Helper to check if data bounds should be sent as {} (all-or-nothing validation)
  const getDataBoundsValue = () => {
    const boundsFields = [
      "glucose_low", "glucose_high",
      "systolic_low", "systolic_high",
      "diastolic_low", "diastolic_high",
      "heart_rate_low", "heart_rate_high",
      "temperature_low", "temperature_high",
      "weight_low", "weight_high",
      "oxygen_low", "oxygen_high",
    ];

    // Check if any field has a value
    const hasAnyValue = boundsFields.some(
      (field) => formData[field] !== "" && formData[field] !== null && formData[field] !== undefined
    );

    // If no values at all, return {} (use organizational defaults)
    if (!hasAnyValue) {
      return { value: {}, error: null, emptyFields: [] };
    }

    // All-or-nothing: if any value is entered, ALL must be entered
    const emptyFields = boundsFields.filter(
      (field) => formData[field] === "" || formData[field] === null || formData[field] === undefined
    );

    // If not all filled, return {} with error (invalid/incomplete data bounds)
    if (emptyFields.length > 0) {
      return {
        value: {},
        error: null,
        emptyFields
      };
    }

    // All fields filled - return the object with sanitized values
    const boundsObj = {};
    boundsFields.forEach((field) => {
      boundsObj[field] = sanitizeField(formData[field]);
    });
    return { value: boundsObj, error: null, emptyFields: [] };
  };

  // Helper function to format date without timezone conversion
  const formatDateForAPI = (date) => {
    if (!date) return null;

    let d;
    if (typeof date === "string") {
      // If it's a string in MM/DD/YYYY format, parse it correctly
      if (date.includes("/")) {
        const [month, day, year] = date.split("/");
        d = new Date(year, month - 1, day); // month is 0-indexed
      } else {
        d = parseDateSafe(date) || new Date(date);
      }
    } else {
      d = parseDateSafe(date) || new Date(date);
    }

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const finalFormData = {
    user: {
      first_name: sanitizeField(formData.first_name),
      last_name: sanitizeField(formData.last_name),
      username: sanitizeField(formData.username),
      email: sanitizeField(formData.email),
      password: sanitizeField(formData.password),
      gender: sanitizeField(formData.gender),
      primary_phone: sanitizeField(formData.primary_phone),
      secondary_phone: sanitizeField(formData.secondary_phone),
      tertiary_phone: sanitizeField(formData.tertiary_phone),
      dob: formatDateForAPI(formData.dob),
      address_line_1: sanitizeField(formData.address_line_1),
      address_line_2: sanitizeField(formData.address_line_2),
      city: sanitizeField(formData.city),
      postal_code: sanitizeField(formData.postal_code),
      state: sanitizeField(formData.state),
      type: "patient",
      created_at: formData.created_at,
    },
    location: sanitizeField(current_location.id),
    rpm: sanitizeField(formData.rpm),
    ccm: sanitizeField(formData.ccm),
    vital_sms_alert: sanitizeField(formData.vital_sms_alert),
    rpm_codes: formData.rpm_codes,
    ccm_codes: formData.ccm_codes,
    preferred_language: sanitizeField(formData.preferred_language),
    case_manager: sanitizeField(
      formData.case_manager ? Number(formData.case_manager) : null
    ),
    provider: sanitizeField(
      formData.provider ? Number(formData.provider) : null
    ),
    secondary_provider: sanitizeField(formData.secondary_provider),
    nurse_id: sanitizeField(
      formData.nurse ? Number(formData.nurse) : null
    ),
    medical_record_number: sanitizeField(formData.medical_record_number),
    facility: sanitizeField(formData.facility),
    data_bounds: getDataBoundsValue().value,
    device_info: {
      imei: sanitizeField(formData.device_imei),
      assigned_at: formatDateForAPI(formData.device_assgined_at),
      type: sanitizeField(formData.device_type),
      name: sanitizeField(formData.device_name),
      ...(formData.device_type === "gateway" && {
        gateway_id: sanitizeField(formData.gateway_id),
      }),
    },
    medications: sanitizeField(formData.medications),
    // chronic_conditions: patientChronicConditions(ccmCodes, extractData.Chronic_conditions)
    chronic_conditions: sanitizeField(formData.chronic_conditions),
    created_at: formatDateForAPI(formData.created_at),
    numbers: contactNumbers,
  };

  const validateForm = () => {
    const newFieldErrors = {};

    // required fields
    if (!formData.first_name.trim())
      newFieldErrors.first_name = "First Name is required";
    if (!formData.last_name.trim())
      newFieldErrors.last_name = "Last Name is required";

    // IMEI stays optional (a patient can be created before a device is
    // assigned), but whatever's entered must match addDeviceModal.js's
    // format rules (SCRUM-641).
    const imei = (formData.device_imei || "").trim();
    if (imei) {
      if (!/^[a-zA-Z0-9]+$/.test(imei)) {
        newFieldErrors.device_imei = "IMEI must contain only letters and numbers";
      } else if (imei.length < 5 || imei.length > 20) {
        newFieldErrors.device_imei = "IMEI must be between 5 and 20 characters";
      }
    }

    // data bounds validation (all-or-nothing)
    const boundsValidation = getDataBoundsValue();
    if (boundsValidation.emptyFields.length > 0) {
      // Add error for each empty field only
      boundsValidation.emptyFields.forEach((field) => {
        newFieldErrors[field] = "This field is required";
      });
    }

    setFieldErrors(newFieldErrors);
    if (Object.keys(newFieldErrors).length > 0) {
      // If data bounds fields have errors, open that section and scroll to it
      const hasDataBoundsError = boundsValidation.emptyFields.length > 0;
      if (hasDataBoundsError) {
        setIsSectionOpen((prev) => ({ ...prev, sec4: true }));
        // Scroll to data bounds section after state update
        setTimeout(() => {
          const dataBoundsSection = document.querySelector(`.${styles.data_bounds}`);
          if (dataBoundsSection) {
            dataBoundsSection.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 100);
      } else {
        // For other errors, scroll to top
        scrollToTopOnError();
      }
      return false;
    }
    return true;
  };

  const uploadDocument = async (patient_id) => {
    if (!patient_id) return;
    const token = localStorage.getItem("authToken");
    const account_id = sessionStorage.getItem("acc_id");

    let fileType = null;
    let file = null;
    if (formData.is_consent_form && formData.consent_form) {
      fileType = "consent";
      file = formData.consent_form;
    } else if (formData.is_doctor_notes && formData.doctor_notes) {
      fileType = "doctor";
      file = formData.doctor_notes;
    }

    if (!file || !fileType) return;

    const url = `${BASE_URL}/patients/${account_id}/documents/`;
    const data = new FormData();
    data.append("documents", file);
    data.append("document_type_0", fileType);
    data.append("patient_id", patient_id);

    try {
      const res = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // Queue the uploaded document for AI processing (fire-and-forget; a
      // failure here must not break the onboarding flow).
      processDocumentsForAI(extractDocumentIds(res?.data));
    } catch (error) {
      handleApiError(error);
    }
  };

  const onboardPatient = async (finalFormData) => {
    const token = localStorage.getItem("authToken");
    const account_id = sessionStorage.getItem("acc_id");
    const url = `${BASE_URL}/patients/${account_id}/${location_id}/onboard-patient/`;

    const hasDocument =
      (formData.is_consent_form && formData.consent_form) ||
      (formData.is_doctor_notes && formData.doctor_notes);

    try {
      setLoading(true);
      const response = await axios.post(url, finalFormData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const patientId = response?.data?.patient_id;

      if (patientId && hasDocument) {
        await uploadDocument(patientId);
      }

      toast.success(
        hasDocument
          ? "Patient onboarded and document uploaded successfully!"
          : "Patient onboarded successfully!"
      );
      navigate("/dashboard");
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const selectedStaffIds = Object.keys(checkedStaff)
      .filter((key) => checkedStaff[key] === true)
      .map((key) => Number(key));

    const data = {
      ...finalFormData,
      created_at: finalFormData.created_at
        ? new Date(finalFormData.created_at).toISOString()
        : null,
      assigned_staff: selectedStaffIds, // Move to root level
    };

    if (validateForm()) {
      onboardPatient(data);
    }
  };

  return (
    <div
      className={styles.create_patient_page}
      style={uploadedPdf ? { padding: "10px 20px" } : {}}
    >
      <div
        className={styles.page_container}
        style={{ gap: openPdf ? "3px" : "0px" }}
      >
        {uploadedPdf && (
          <div
            className={styles.pdf_toggler}
            onClick={() => setOpenPdf(!openPdf)}
            style={{
              right: openPdf ? "3px" : "15px",
              top: openPdf ? "3px" : "10px",
            }}
          >
            <FontAwesomeIcon icon={faPrint} />
          </div>
        )}

        <div
          className={`${styles.form_container} ${
            uploadedPdf ? styles.split_view : ""
          } ${uploadedPdf ? (fileLoading ? styles.file_loading : "") : ""} ${
            uploadedPdf && !openPdf ? styles.pdf_split_view : ""
          }`}
        >
          {fileLoading && (
            <div className={styles.overlay}>
              <Spinner />
              <p>Extracting data, please wait...</p>
            </div>
          )}

          <div className={styles.create_header}>
            <p className={styles.heading}>Create New Patient</p>
            <Link to={backLink} className={styles.back_btn}>
              <FontAwesomeIcon icon={faArrowLeft} /> Go Back
            </Link>
          </div>
          <form
            className={styles.form_wrapper}
            onSubmit={handleSubmit}
            noValidate
          >
            {/* Drop File */}
            {!uploadedPdf ? (
              <>
                <div
                  className={styles.upload_wrapper}
                  style={{ width: "100%" }}
                >
                  <div
                    className={styles.drop_zone}
                    onDrop={handleDrop}
                    onDragOver={(e) => e.preventDefault()}
                    onClick={handleDropZoneClick}
                  >
                    <input
                      type="file"
                      accept=".pdf"
                      id="consent_form"
                      name="consent_form"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                    <div className={styles.inner_drop_zone}>
                      <div className={styles.drop_zone_right}>
                        <img src={cloud} alt="Cloud" />
                        {formData.consent_form ? (
                          <p className={styles.file_name}>
                            {formData.consent_form.name}
                          </p>
                        ) : formData.doctor_notes ? (
                          <p className={styles.file_name}>
                            {formData.doctor_notes.name}
                          </p>
                        ) : (
                          <p>Drop File here</p>
                        )}
                        <p>(Pdf)</p>
                      </div>
                      <p>Or</p>

                      <div className={styles.drop_zone_right}>
                        <button className={styles.drop_btn} type="button">
                          Browse
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className={styles.choose_file}>
                    <label>
                      <input
                        type="checkbox"
                        name="is_consent_form"
                        checked={formData.is_consent_form}
                        onChange={handleFileCheckBoxChange}
                      />
                      Consent Form
                    </label>

                    <label>
                      <input
                        type="checkbox"
                        name="is_doctor_notes"
                        checked={formData.is_doctor_notes}
                        onChange={handleFileCheckBoxChange}
                      />
                      Doctor Notes
                    </label>
                  </div>
                </div>
              </>
            ) : (
              <div className={styles.empty_div}></div>
            )}

            <div
              className={`${styles.form_section} ${
                isSectionOpen.sec1 ? "" : styles.close
              }`}
            >
              <div
                className={styles.section_header}
                onClick={() => toggleSection("sec1")}
              >
                <div className={styles.section_number}>1</div>
                <div>
                  <p className={styles.section_heading}>Patient</p>
                  <p className={styles.sub_heading}>
                    Basic Patient Information
                  </p>
                </div>
                <div className={styles.drop_icon}>
                  <FontAwesomeIcon icon={faChevronDown} />
                </div>
              </div>

              <div className={styles.input_fields}>
                <div className={styles.input_group}>
                  {/* First Name */}
                  <div className={styles.input_wrapper}>
                    <label>First Name</label>
                    <input
                      type="text"
                      placeholder="First Name"
                      name="first_name"
                      className={styles.input}
                      value={formData.first_name}
                      onChange={handleChange}
                    />
                    {fieldErrors.first_name && (
                      <span className={styles.error_text}>
                        {fieldErrors.first_name}
                      </span>
                    )}
                  </div>

                  {/* Last Name */}
                  <div className={styles.input_wrapper}>
                    <label>Last Name</label>
                    <input
                      type="text"
                      placeholder="Last Name"
                      name="last_name"
                      className={styles.input}
                      value={formData.last_name}
                      onChange={handleChange}
                    />
                    {fieldErrors.last_name && (
                      <span className={styles.error_text}>
                        {fieldErrors.last_name}
                      </span>
                    )}
                  </div>
                </div>

                <div className={styles.input_group}>
                  {/* Username */}
                  <div className={styles.input_wrapper}>
                    <label>Username</label>
                    <input
                      type="text"
                      placeholder="Username"
                      name="username"
                      className={styles.input}
                      value={formData.username}
                      autoComplete="off"
                      onChange={handleChange}
                    />
                  </div>

                  {/* Email */}
                  <div className={styles.input_wrapper}>
                    <label>Email</label>
                    <input
                      type="email"
                      placeholder="user@example.com"
                      name="email"
                      className={styles.input}
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {fieldErrors.email && (
                      <span className={styles.error_text}>
                        {fieldErrors.email}
                      </span>
                    )}
                  </div>
                </div>

                <div className={styles.input_group}>
                  {/* Password */}
                  <div className={styles.input_wrapper}>
                    <Input
                      type="password"
                      placeholder="Enter your password"
                      label="Password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      autoComplete="new-password"
                      // variant="filled"
                      // size="medium"
                      // error={errors.password}
                      // startIcon={<LockIcon />}

                      helperText="Must be at least 8 characters long"
                    />
                    {fieldErrors.password && (
                      <span className={styles.error_text}>
                        {fieldErrors.password}
                      </span>
                    )}
                    {/* <label>Password</label>
                    <input
                      type="password"
                      placeholder="Password"
                      name="password"
                      className={styles.input}
                      value={formData.password}
                      autoComplete="password"
                      onChange={handleChange}
                    /> */}
                  </div>

                  {/* Gender */}
                  <div className={styles.input_wrapper}>
                    <label>Gender</label>
                    <Select
                      onChange={(value) =>
                        handleChange({
                          target: {
                            name: "gender",
                            value,
                          },
                        })
                      }
                      value={formData.gender}
                    >
                      <SelectTrigger>
                        <SelectValue placeholder="Select gender">
                          {formData.gender === "male"
                            ? "Male"
                            : formData.gender === "female"
                            ? "Female"
                            : "Select gender"}
                        </SelectValue>
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="male">Male</SelectItem>
                        <SelectItem value="female">Female</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>

                <div className={styles.input_group}>
                  {/* Confirm Password */}
                  <div className={styles.input_wrapper}>
                    <Input
                      type="password"
                      placeholder="Enter your password"
                      label="Confirm Password"
                      name="confirm_password"
                      value={formData.confirm_password}
                      onChange={handleChange}
                      autoComplete="new-password"
                      // variant="filled"
                      // size="medium"
                      // error={errors.password}
                      // startIcon={<LockIcon />}

                      // helperText="Must be at least 8 characters long"
                    />
                    {fieldErrors.confirm_password && (
                      <span className={styles.error_text}>
                        {fieldErrors.confirm_password}
                      </span>
                    )}
                    {/* <label>Confirm password</label>
                    <input
                      type="password"
                      placeholder="Confirm Password"
                      name="confirm_password"
                      className={styles.input}
                      value={formData.confirm_password}
                      autoComplete="password"
                      onChange={handleChange}
                    /> */}
                  </div>

                  {/* Phone */}
                  <div className={styles.input_wrapper}>
                    <label>Primary Phone</label>
                    {/* <input
                      type="number"
                      // placeholder="(301) 123-4567"
                      name="primary_phone"
                      className={clsx(styles.input, "no-arrows")}
                      value={formData.primary_phone}
                      onChange={handleChange}
                    /> */}

                    <Input
                      name="primary_phone"
                      mask={true}
                      maskPattern="(999) 999-9999"
                      onChange={handleChange}
                      className={clsx(styles.input)}
                      value={formData.primary_phone}
                    />
                  </div>
                </div>

                <div className={styles.input_group}>
                  {/* Case Manager */}
                  <div className={styles.input_wrapper}>
                    <label>Case Manager</label>
                    <Select
                      onChange={(value) =>
                        handleChange({
                          target: {
                            name: "case_manager",
                            value: value,
                          },
                        })
                      }
                      value={formData.case_manager}
                    >
                      <SelectTrigger>
                        <SelectValue placeholder="Select case manager">
                          {(() => {
                            const cm = caseManagers?.find(
                              (_cm) => _cm.id === formData.case_manager
                            );
                            if (!cm) return "Select case manager";
                            const displayName = cm.user_type
                              ? `${cm.first_name} ${cm.last_name} - ${cm.user_type}`
                              : `${cm.first_name} ${cm.last_name}`;
                            return displayName;
                          })()}
                        </SelectValue>
                      </SelectTrigger>
                      <SelectContent searchField={true}>
                        {caseManagers?.map((caseManager) => {
                          const displayName = caseManager.user_type
                            ? `${caseManager.first_name} ${caseManager.last_name} - ${caseManager.user_type}`
                            : `${caseManager.first_name} ${caseManager.last_name}`;
                          return (
                            <SelectItem
                              key={caseManager.id}
                              value={caseManager.id}
                              disabled={
                                caseManager.can_be_assigned === false &&
                                caseManager.id !== formData.case_manager
                              }
                            >
                              {displayName}
                            </SelectItem>
                          );
                        })}
                      </SelectContent>
                    </Select>
                  </div>

                  <div className={styles.input_wrapper}>
                    <label>Date of birth</label>

                    <DatePicker
                      onlyIcon={true}
                      autoFormatDate={true}
                      selectedDate={formData.dob}
                      onCancelSelect={() =>
                        handleChange({
                          target: {
                            name: "dob",
                            value: "",
                          },
                        })
                      }
                      onDateSelect={(selectedDate) => {
                        const formatted = new Intl.DateTimeFormat("en-US", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                        }).format(selectedDate);
                        handleChange({
                          target: {
                            name: "dob",
                            value: formatted,
                          },
                        });
                      }}
                      placeholder="MM-DD-YYYY"
                    />
                  </div>
                </div>

                <div className={styles.input_group}>
                  {/* Prefered Language */}
                  <div className={styles.input_wrapper}>
                    <label>Prefered Language</label>
                    <Select
                      onChange={(value) =>
                        handleChange({
                          target: {
                            name: "preferred_language",
                            value,
                          },
                        })
                      }
                      value={formData.preferred_language}
                    >
                      <SelectTrigger>
                        <SelectValue placeholder="Select a Language">
                          {formData.preferred_language || "Select a Language"}
                        </SelectValue>
                      </SelectTrigger>
                      <SelectContent>
                        {languages.map((language, index) => (
                          <SelectItem key={index} value={language}>
                            {language}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                    {fieldErrors.preferred_language && (
                      <span className={styles.error_text}>
                        {fieldErrors.preferred_language}
                      </span>
                    )}
                  </div>
                  {/* Prefered Lenguage */}
                  <div className={styles.input_wrapper}>
                    <label>Consent Date</label>

                    <DatePicker
                      onlyIcon={true}
                      selectedDate={formData.created_at}
                      onCancelSelect={() =>
                        handleChange({
                          target: {
                            name: "created_at",
                            value: "",
                          },
                        })
                      }
                      onDateSelect={(selectedDate) => {
                        // const formatted = new Intl.DateTimeFormat("en-US", {
                        //   year: "numeric",
                        //   month: "2-digit",
                        //   day: "2-digit",
                        // }).format(selectedDate);
                        handleChange({
                          target: {
                            name: "created_at",
                            value: selectedDate,
                          },
                        });
                      }}
                      placeholder="Select consent date"
                    />
                  </div>
                </div>

                <div className={styles.input_group}>
                  {/* Medical Record Number */}
                  <div className={styles.input_wrapper}>
                    <label>Medical Record Number</label>
                    <input
                      type="text"
                      placeholder="Enter MRN"
                      name="medical_record_number"
                      className={styles.input}
                      value={formData.medical_record_number}
                      onChange={handleChange}
                    />
                  </div>

                  <div className={styles.input_wrapper}></div>
                </div>

                <div className={styles.input_group}>
                  {/* Programs */}
                  <div className={styles.input_wrapper}>
                    <label>Programs:</label>
                    <div className={styles.program_container}>
                      <div className={styles.switch_wrapper}>
                        <label className={`${styles.switch}`}>
                          <input
                            type="checkbox"
                            name="rpm"
                            className={`${styles.input} ${styles.checkbox}`}
                            checked={formData.rpm}
                            onChange={handleCheckBoxChange}
                            disabled={!formData.ccm}
                          />
                          <span
                            className={styles.slider}
                            style={
                              !formData.ccm
                                ? { cursor: "not-allowed", opacity: "0.5" }
                                : undefined
                            }
                          ></span>
                        </label>
                        <span>RPM</span>
                      </div>
                      <div className={styles.switch_wrapper}>
                        <label className={`${styles.switch}`}>
                          <input
                            type="checkbox"
                            name="ccm"
                            className={`${styles.input} ${styles.checkbox}`}
                            checked={formData.ccm}
                            onChange={handleCheckBoxChange}
                          />
                          <span className={styles.slider}></span>
                        </label>
                        <span>CCM</span>
                      </div>
                    </div>
                  </div>
                  {/* Additional contacts UI */}
                  <div className={styles.input_wrapper}>
                    <label>Contacts</label>
                    {Array.isArray(contactNumbers) &&
                      contactNumbers?.map((contact) => (
                        <section
                          className={styles.contact_wrapper}
                          key={(contact.number || "").replace(/\D/g, "")}
                        >
                          <Input
                            // className={clsx(styles.input, "no-arrows")}
                            mask={true}
                            maskPattern="(999) 999-9999"
                            type="text"
                            value={contact.number}
                            readOnly
                          />

                          <Button
                            variant="normal"
                            onClick={() => {
                              setEditingContactId(contact.number);
                              setIsContactsModalOpen(true);
                            }}
                          >
                            <FaEdit />
                          </Button>
                          <Button
                            variant="normal"
                            onClick={() => {
                              setContactNumbers((prev) =>
                                (Array.isArray(prev) ? prev : []).filter(
                                  (c) =>
                                    (c.number || "").replace(/\D/g, "") !==
                                    (contact.number || "").replace(/\D/g, "")
                                )
                              );
                            }}
                          >
                            <FaTrash />
                          </Button>
                        </section>
                      ))}
                    <Button
                      variant="primary"
                      disabled={
                        (Array.isArray(contactNumbers)
                          ? contactNumbers.length
                          : 0) >= 2
                      }
                      onClick={() => {
                        setEditingContactId(null);
                        setIsContactsModalOpen(true);
                      }}
                    >
                      Add Contact
                    </Button>
                    {showVitalSmsToggle && (
                      <div className={styles.switch_wrapper} style={{ marginTop: "1rem" }}>
                        <label className={`${styles.switch}`}>
                          <input
                            type="checkbox"
                            name="vital_sms_alert"
                            className={`${styles.input} ${styles.checkbox}`}
                            checked={formData.vital_sms_alert}
                            onChange={handleCheckBoxChange}
                          />
                          <span className={styles.slider}></span>
                        </label>
                        <span>Vital SMS Alert</span>
                      </div>
                    )}

                    <AddContactisView
                      open={isContactsModalOpen}
                      setOpen={setIsContactsModalOpen}
                      contactId={editingContactId}
                      numbers={contactNumbers}
                      setNumbers={setContactNumbers}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`${styles.form_section} ${
                isSectionOpen.sec2 ? "" : styles.close
              }`}
            >
              <div
                className={styles.section_header}
                onClick={() => toggleSection("sec2")}
              >
                <div className={styles.section_number}>2</div>
                <div>
                  <p className={styles.section_heading}>Additional</p>
                  <p className={styles.sub_heading}>
                    Additional Patient information
                  </p>
                </div>

                <div className={styles.drop_icon}>
                  <FontAwesomeIcon icon={faChevronDown} />
                </div>
              </div>

              <div className={styles.input_fields}>
                <div className={styles.input_group}>
                  {/* Address Line 1 */}
                  <div className={styles.input_wrapper}>
                    <label>Address Line 1</label>
                    <input
                      type="text"
                      placeholder="Address Line 1"
                      name="address_line_1"
                      className={styles.input}
                      value={formData.address_line_1}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Address Line 2 */}
                  <div className={styles.input_wrapper}>
                    <label>Address Line 2</label>
                    <input
                      type="text"
                      placeholder="Address Line 2"
                      name="address_line_2"
                      className={styles.input}
                      value={formData.address_line_2}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className={styles.input_group}>
                  {/* City */}
                  <div className={styles.input_wrapper}>
                    <label>City</label>
                    <input
                      type="text"
                      placeholder="City"
                      name="city"
                      className={styles.input}
                      value={formData.city}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Postal Code */}
                  <div className={styles.input_wrapper}>
                    <label>Postal Code</label>
                    <input
                      type="number"
                      placeholder="72000"
                      name="postal_code"
                      className={clsx(styles.input, "no-arrows")}
                      value={formData.postal_code}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className={styles.input_group}>
                  {/* State */}
                  <div className={styles.input_wrapper}>
                    <label>State</label>
                    <Select
                      onChange={(value) =>
                        handleChange({
                          target: {
                            name: "state",
                            value,
                          },
                        })
                      }
                      value={formData.state}
                    >
                      <SelectTrigger>
                        <SelectValue placeholder="Select a state">
                          {formData.state || "Select a state"}
                        </SelectValue>
                      </SelectTrigger>
                      <SelectContent>
                        {states.map((state, index) => (
                          <SelectItem key={index} value={state}>
                            {state}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>

                  {/* Provider */}
                  <div className={styles.input_wrapper}>
                    <label>Provider</label>
                    <Select
                      onChange={(value) => {
                        if (value === "add_new_provider") {
                          openAddProviderModal();
                        } else {
                          handleChange({
                            target: {
                              name: "provider",
                              value,
                            },
                          });
                        }
                      }}
                      value={formData.provider}
                    >
                      <SelectTrigger>
                        <SelectValue placeholder="Select provider">
                          {(() => {
                            const provider = providers?.find(
                              (p) => p.id === formData.provider
                            );
                            return provider
                              ? `${provider.first_name} ${provider.last_name}`
                              : "Select provider";
                          })()}
                        </SelectValue>
                      </SelectTrigger>
                      <SelectContent searchField={true}>
                        {providers?.map((provider) => (
                          <SelectItem key={provider.id} value={provider.id}>
                            {provider.first_name} {provider.last_name}
                          </SelectItem>
                        ))}
                        {/*
                          <SelectItem value="add_new_provider">
                            | + Add new Provider |
                          </SelectItem>
                        */}
                      </SelectContent>
                    </Select>
                  </div>

                  {isAddProviderModalOpen && (
                    <AddProviderModal
                      isOpen={isAddProviderModalOpen}
                      onClose={closeAddProviderModal}
                      render={renderProvider}
                      reRenderer={setRenderProvider}
                    />
                  )}
                </div>

            <div className={styles.input_group}>
  {/* Secondary Provider */}
  <div className={styles.input_wrapper}>
    <label>Secondary Provider</label>
    <input
      type="text"
      placeholder="Secondary Provider"
      name="secondary_provider"
      className={styles.input}
      value={formData.secondary_provider}
      onChange={handleChange}
    />
  </div>

  {/* Nurse Dropdown */}
  <div className={styles.input_wrapper}>
    <label>Nurse</label>

    <Select
      onChange={(value) =>
        handleChange({
          target: {
            name: "nurse",
            value,
          },
        })
      }
      value={formData.nurse || ""}
      disabled={isLoadingStaff}
    >
      <SelectTrigger>
        <SelectValue placeholder={
          isLoadingStaff ? "Loading nurses..." : "Select Nurse"
        }>
          {(() => {
            const nurse = nurseList?.find(
              (n) => n.id === formData.nurse
            );
            return nurse
              ? `${nurse.first_name} ${nurse.last_name}`
              : null;
          })()}
        </SelectValue>
      </SelectTrigger>
      <SelectContent searchField={true}>
        {nurseList?.map((nurse) => (
          <SelectItem key={nurse.id} value={nurse.id}>
            {nurse.first_name} {nurse.last_name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>

    {/* Error handling */}
    {staffError && (
      <small className={styles.error}>
        Failed to load nurses
      </small>
    )}
  </div>
        </div>

              <div className={styles.input_group}>
  {formData.rpm ? (
    <div className={styles.input_wrapper} style={{ width: "100%" }}>
      <label>RPM Diagnosis Codes</label>

      <MultiSelectTagInput
        name="rpm_codes"
        placeholder="Search and select Chronic Conditions..."
        manual={true}
                        // options={renderMultiselectOptions(
                        //   rpmCodes,
                        //   "id",
                        //   (code) => `${code.description} (${code.code})`
                        // )}
        options={rpmCodes?.map((code) => ({
          id: code,
          name: code,
        }))}
        value={formData.rpm_codes}
        onChange={handleMultiSelectInputChange}
      />
                      {/* RPM missing Codes */}
      {rpmMissingCodes?.length > 0 && (
        <div className={styles.missing_codes}>
          <label>
                            <label>Missing Codes:</label>
            <div className={styles.missing_codes_list}>
              {rpmMissingCodes?.map((code, index) => (
                <span key={index}>
                  <FontAwesomeIcon icon={faCircle} />
                  {code}
                </span>
              ))}
            </div>
          </label>
        </div>
      )}
    </div>
  ) : formData.ccm ? (
                    // {/* CCM Diagnosis Codes */}
                    <div className={styles.input_wrapper}>
      <label>CCM Diagnosis Codes</label>
      <MultiSelectTagInput
        name="ccm_codes"
        placeholder="Search and select Chronic Conditions..."
        manual={true}
        options={ccmCodes?.map((code) => ({
                          id: code.icd_code, // Using icd_code as the ID to match RPM behavior
          name: `${code.name} (${code.icd_code})`,
        }))}
        value={formData.ccm_codes}
        onChange={handleMultiSelectInputChange}
                        // onChange={() => {}}
                      />
                      {/* CCM missing Codes */}
                      {ccmMissingCodes?.length > 0 && (
                        <div className={styles.missing_codes}>
                          <label>
                            <label>Missing Codes:</label>
                            <div className={styles.missing_codes_list}>
                              {ccmMissingCodes?.map((code, index) => (
                                <span key={index}>
                                  <FontAwesomeIcon icon={faCircle} />
                                  {code}
                                </span>
                              ))}
                            </div>
                          </label>
                        </div>
                      )}
    </div>
  ) : null}
              </div>

                <div className={styles.input_group}>
                  {formData.rpm && formData.ccm ? (
                    <div className={styles.input_wrapper}>
                      <label>CCM Diagnosis Codes</label>
                      <MultiSelectTagInput
                        name="ccm_codes"
                        placeholder="Search and select Chronic Conditions..."
                        manual={true}
                        options={ccmCodes?.map((code) => ({
                          id: code.icd_code, // Using icd_code as the ID to match RPM behavior
                          name: `${code.name} (${code.icd_code})`,
                        }))}
                        value={formData.ccm_codes}
                        onChange={handleMultiSelectInputChange}
                        // onChange={() => {}}
                      />
                      {/* CCM missing Codes */}
                      {ccmMissingCodes?.length > 0 && (
                        <div className={styles.missing_codes}>
                          <label>
                            <label>Missing Codes:</label>
                            <div className={styles.missing_codes_list}>
                              {ccmMissingCodes?.map((code, index) => (
                                <span key={index}>
                                  <FontAwesomeIcon icon={faCircle} />
                                  {code}
                                </span>
                              ))}
                            </div>
                          </label>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className={styles.input_wrapper}></div>
                  )}

                  <div className={styles.input_wrapper}></div>
                </div>

                <div className={styles.acknowledgements}>
                  <label>
                    <input
                      type="checkbox"
                      name="acknowledgment"
                      checked={formData.acknowledgment}
                      onChange={handleAcknowledgementCheck}
                    />
                    I acknowledge that I am receiving at no charge the
                    monitoring device listed below so that I can participate in
                    the remote monitoring and/or chronic care management
                    program.
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      name="device_policy"
                      checked={formData.device_policy}
                      onChange={handleAcknowledgementCheck}
                    />
                    The device is the property of the Doctor and is free for me
                    to use while I participate in the program. If I discontinue
                    participation in this program, it is my responsibility to
                    return the device in working order. I will not intentionally
                    tamper with any RPM device or technology used.
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      name="participation_agreement"
                      checked={formData.participation_agreement}
                      onChange={handleAcknowledgementCheck}
                    />
                    I agree to participate in at least one monthly check-in with
                    my care manager to discuss improving my health. I agree that
                    I will receive text messages and emails.
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      name="rpm_disclaimer"
                      checked={formData.rpm_disclaimer}
                      onChange={handleAcknowledgementCheck}
                    />
                    RPM services are NOT emergency services and your data WILL
                    NOT BE MONITORED 24/7. If you think you are experiencing a
                    medical emergency, CALL 911 IMMEDIATELY.
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      name="verbal_consent"
                      checked={formData.verbal_consent}
                      onChange={handleAcknowledgementCheck}
                    />
                    Verbal Concent
                  </label>
                </div>
              </div>
            </div>

            {/* <div
              className={`${styles.form_section} ${
                isSectionOpen.sec3 ? "" : styles.close
              }`}
            >
              <div
                className={styles.section_header}
                onClick={() => toggleSection("sec3")}
              >
                <div className={styles.section_number}>3</div>
                <div>
                  <p className={styles.section_heading}>Staff Members</p>
                  <p className={styles.sub_heading}>Assign Staff Members</p>
                </div>

                <div className={styles.drop_icon}>
                  <FontAwesomeIcon icon={faChevronDown} />
                </div>
              </div>

              <div className={styles.input_fields}>
                <div className={styles.staff_section}>
                  <div className={styles.staff_members}>
                    {staff &&
                      staff.map((staff) => (
                        <label key={staff.id}>
                          <input
                            type="checkbox"
                            name={staff.id}
                            checked={checkedStaff[staff.id] || false}
                            onChange={handleStaffCheckBoxChange}
                          />
                          {staff.user.first_name} {staff.user.last_name}
                        </label>
                      ))}
                  </div>

                  {adminStaff.length > 0 && (
                    <p>
                      The following are admins or medical Billers and are
                      assigned all patients by default
                    </p>
                  )}

                  <div className={styles.staff_members}>
                    {adminStaff &&
                      adminStaff.map((staff) => (
                        <label key={staff.id}>
                          <input
                            type="checkbox"
                            name={staff.id}
                            checked={true}
                            readOnly
                          />
                          {staff.user.first_name} {staff.user.last_name}
                        </label>
                      ))}
                  </div>
                </div>
              </div>
            </div> */}

            <div
              className={`${styles.form_section} ${
                isSectionOpen.sec4 ? "" : styles.close
              } ${styles.data_bounds}`}
            >
              <div
                className={styles.section_header}
                onClick={() => toggleSection("sec4")}
              >
                <div className={styles.section_number}>3</div>
                <div>
                  <p className={styles.section_heading}>Data bounds</p>
                  <p className={styles.sub_heading}>Patient Thresholds </p>
                </div>

                <div className={styles.drop_icon}>
                  <FontAwesomeIcon icon={faChevronDown} />
                </div>
              </div>

              <div className={styles.input_fields}>
                <div className={styles.input_status}>
                  <p className={styles.high}>Low</p>
                  <p className={styles.low}>High</p>
                </div>

                <div className={styles.input_group}>
                  {/* Glucose */}
                  <label>Glucose:</label>
                  <div className={styles.input_wrapper}>
                    <input
                      type="number"
                      placeholder="70"
                      name="glucose_low"
                      className={clsx(styles.input, "no-arrows")}
                      value={formData.glucose_low}
                      onChange={handleChange}
                      style={fieldErrors.glucose_low ? { border: "1px solid #d93025" } : {}}
                    />
                    <input
                      type="number"
                      placeholder="130"
                      name="glucose_high"
                      className={clsx(styles.input, "no-arrows")}
                      value={formData.glucose_high}
                      onChange={handleChange}
                      style={fieldErrors.glucose_high ? { border: "1px solid #d93025" } : {}}
                    />
                  </div>
                </div>

                <div className={styles.input_group}>
                  {/* Systolic */}
                  <label>Systolic:</label>
                  <div className={styles.input_wrapper}>
                    <input
                      type="number"
                      placeholder="95"
                      name="systolic_low"
                      className={clsx(styles.input, "no-arrows")}
                      value={formData.systolic_low}
                      onChange={handleChange}
                      style={fieldErrors.systolic_low ? { border: "1px solid #d93025" } : {}}
                    />
                    <input
                      type="number"
                      placeholder="170"
                      name="systolic_high"
                      className={clsx(styles.input, "no-arrows")}
                      value={formData.systolic_high}
                      onChange={handleChange}
                      style={fieldErrors.systolic_high ? { border: "1px solid #d93025" } : {}}
                    />
                  </div>
                </div>

                <div className={styles.input_group}>
                  {/* Diastolic */}
                  <label>Diastolic:</label>
                  <div className={styles.input_wrapper}>
                    <input
                      type="number"
                      placeholder="45"
                      name="diastolic_low"
                      className={clsx(styles.input, "no-arrows")}
                      value={formData.diastolic_low}
                      onChange={handleChange}
                      style={fieldErrors.diastolic_low ? { border: "1px solid #d93025" } : {}}
                    />
                    <input
                      type="number"
                      placeholder="105"
                      name="diastolic_high"
                      className={clsx(styles.input, "no-arrows")}
                      value={formData.diastolic_high}
                      onChange={handleChange}
                      style={fieldErrors.diastolic_high ? { border: "1px solid #d93025" } : {}}
                    />
                  </div>
                </div>

                <div className={styles.input_group}>
                  {/* Heart Rate */}
                  <label>Heart Rate:</label>
                  <div className={styles.input_wrapper}>
                    <input
                      type="number"
                      placeholder="50"
                      name="heart_rate_low"
                      className={clsx(styles.input, "no-arrows")}
                      value={formData.heart_rate_low}
                      onChange={handleChange}
                      style={fieldErrors.heart_rate_low ? { border: "1px solid #d93025" } : {}}
                    />
                    <input
                      type="number"
                      placeholder="100"
                      name="heart_rate_high"
                      className={clsx(styles.input, "no-arrows")}
                      value={formData.heart_rate_high}
                      onChange={handleChange}
                      style={fieldErrors.heart_rate_high ? { border: "1px solid #d93025" } : {}}
                    />
                  </div>
                </div>

                <div className={styles.input_group}>
                  {/* Weight */}
                  <label>Weight:</label>
                  <div className={styles.input_wrapper}>
                    <input
                      type="number"
                      placeholder="140"
                      name="weight_low"
                      className={clsx(styles.input, "no-arrows")}
                      value={formData.weight_low}
                      onChange={handleChange}
                      style={fieldErrors.weight_low ? { border: "1px solid #d93025" } : {}}
                    />
                    <input
                      type="number"
                      placeholder="220"
                      name="weight_high"
                      className={clsx(styles.input, "no-arrows")}
                      value={formData.weight_high}
                      onChange={handleChange}
                      style={fieldErrors.weight_high ? { border: "1px solid #d93025" } : {}}
                    />
                  </div>
                </div>

                <div className={styles.input_group}>
                  {/* Oxygen */}
                  <label>Oxygen:</label>
                  <div className={styles.input_wrapper}>
                    <input
                      type="number"
                      placeholder="90"
                      name="oxygen_low"
                      className={clsx(styles.input, "no-arrows")}
                      value={formData.oxygen_low}
                      onChange={handleChange}
                      style={fieldErrors.oxygen_low ? { border: "1px solid #d93025" } : {}}
                    />
                    <input
                      type="number"
                      placeholder="100"
                      name="oxygen_high"
                      className={clsx(styles.input, "no-arrows")}
                      value={formData.oxygen_high}
                      onChange={handleChange}
                      style={fieldErrors.oxygen_high ? { border: "1px solid #d93025" } : {}}
                    />
                  </div>
                </div>

                <div className={styles.input_group}>
                  {/* Temperature */}
                  <label>Temperature:</label>
                  <div className={styles.input_wrapper}>
                    <input
                      type="number"
                      placeholder="96"
                      name="temperature_low"
                      value={formData.temperature_low}
                      className={clsx(styles.input, "no-arrows")}
                      onChange={handleChange}
                      style={fieldErrors.temperature_low ? { border: "1px solid #d93025" } : {}}
                    />
                    <input
                      type="number"
                      placeholder="100"
                      name="temperature_high"
                      className={clsx(styles.input, "no-arrows")}
                      value={formData.temperature_high}
                      onChange={handleChange}
                      style={fieldErrors.temperature_high ? { border: "1px solid #d93025" } : {}}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`${styles.form_section} ${
                isSectionOpen.sec5 ? "" : styles.close
              } ${styles.device_info}`}
            >
              <div
                className={styles.section_header}
                onClick={() => toggleSection("sec5")}
              >
                <div className={styles.section_number}>4</div>
                <div>
                  <p className={styles.section_heading}>Devices</p>
                  <p className={styles.sub_heading}>
                    Assign Devices to Patient
                  </p>
                </div>

                <div className={styles.drop_icon}>
                  <FontAwesomeIcon icon={faChevronDown} />
                </div>
              </div>

              <div className={styles.input_fields}>
                <div className={styles.input_group}>
                  {/* Device Type */}
                  <div className={styles.input_wrapper}>
                    <label>Device Type</label>
                    <Select
                      onChange={(value) =>
                        setFormData((prev) => ({ ...prev, device_type: value }))
                      }
                      value={formData.device_type}
                    >
                      <SelectTrigger>
                        <SelectValue placeholder="Select device type">
                          {formData.device_type && (
                            <p>
                              {formData.device_type === "cellular"
                                ? "Cellular"
                                : "Gateway"}
                            </p>
                          )}
                        </SelectValue>
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem key="cellular" value="cellular">
                          Cellular
                        </SelectItem>
                        <SelectItem key="gateway" value="gateway">
                          Gateway
                        </SelectItem>
                      </SelectContent>
                    </Select>
                  </div>

                  <div className={styles.input_wrapper}></div>
                </div>

                <div className={styles.input_group}>
                  {/* Name */}
                  <div className={styles.input_wrapper}>
                    <label>Device Name</label>
                    <div
                      style={{
                        width: "100%",
                        opacity: formData.device_type ? "1" : "0.4",
                        pointerEvents: formData.device_type ? "auto" : "none",
                      }}
                    >
                      <Select
                        onChange={(value) =>
                          setFormData((prev) => ({
                            ...prev,
                            device_name: value,
                          }))
                        }
                        value={formData.device_name}
                      >
                        <SelectTrigger>
                          <SelectValue placeholder="Select a device">
                            {/* <p>{name}</p> */}
                            {formData.device_name && (
                              <p>
                                {
                                  tenoviDevices.find(
                                    (device) =>
                                      device.value === formData.device_name
                                  )?.label
                                }
                              </p>
                            )}
                          </SelectValue>
                        </SelectTrigger>
                        <SelectContent>
                          {tenoviDevices
                            ?.filter(
                              (device) => device.type === formData.device_type
                            )
                            .map((device, index) => (
                              <SelectItem
                                key={device.value}
                                value={device.value}
                              >
                                {device.label}
                              </SelectItem>
                            ))}
                        </SelectContent>
                      </Select>
                    </div>
                  </div>

                  <div className={styles.input_wrapper}></div>
                </div>

                <div className={styles.input_group}>
                  {/* IMEI */}
                  <div className={styles.input_wrapper}>
                    <label>IMEI</label>
                    <input
                      type="text"
                      placeholder="Enter IMEI (5-20 characters)"
                      name="device_imei"
                      className={styles.input}
                      maxLength={20}
                      value={formData.device_imei}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        if (e.key === " ") e.preventDefault();
                      }}
                    />
                    {fieldErrors.device_imei && (
                      <span className={styles.error_text}>
                        {fieldErrors.device_imei}
                      </span>
                    )}
                  </div>

                  <div className={styles.input_wrapper}></div>
                </div>

                {formData.device_type === "gateway" && (
                  <div className={styles.input_group}>
                    {/* Gateway ID */}
                    <div className={styles.input_wrapper}>
                      <label>Gateway Id</label>
                      <input
                        type="text"
                        placeholder="Gateway Id"
                        name="gateway_id"
                        className={styles.input}
                        value={formData.gateway_id}
                        onChange={handleChange}
                      />
                    </div>

                    <div className={styles.input_wrapper}></div>
                  </div>
                )}
                <div className={styles.input_group}>
                  {/* IMEI */}
                  <div className={styles.input_wrapper}>
                    <label>Assignment Date</label>
                    <DatePicker
                      selectedDate={formData.device_assgined_at}
                      onCancelSelect={() =>
                        handleChange({
                          target: {
                            name: "device_assgined_at",
                            value: "",
                          },
                        })
                      }
                      onDateSelect={(selectedDate) => {
                        const formatted = new Intl.DateTimeFormat("en-US", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                        }).format(selectedDate);
                        handleChange({
                          target: {
                            name: "device_assgined_at",
                            value: formatted,
                          },
                        });
                      }}
                      placeholder="Select assignment date"
                    />
                  </div>

                  <div className={styles.input_wrapper}></div>
                </div>
              </div>
            </div>

            <button type="submit" className={styles.submit_btn}>
              {loading ? "Onboarding..." : "Onboard"}
            </button>
          </form>
        </div>

        {/* PDF Preview */}
        {uploadedPdf && (
          <div
            className={styles.pdf_preview_container}
            style={{ width: openPdf ? "50%" : "0%", overflow: "hidden" }}
          >
            <div className={styles.toggler_spacer}></div>
            <div
              className={`${styles.pdf_preview}`}
              style={{
                transform: !openPdf ? "translateX(101%)" : "translateX(0%)",
              }}
            >
              <iframe
                src={`${uploadedPdf}`}
                style={{
                  width: "100%",
                  height: "100%",
                  border: "0",
                  borderRadius: "13px",
                }}
                title="PDF Preview"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreatePatient;